import {
  checkEffectiveTime,
  checkHasSelectSupplierProduct, receiveCheckResult, startCheckStep,
  checkHasSelectLabel
} from "@/components/QuotationManagement/components-productQuotation/utils/checkSave.utils";
import {isArray} from "my-tools-kit";
import {
  checkCityRegionList,
  checkRegionList
} from "@/components/QuotationManagement/components-productQuotation/freightPrice";

/**
 * 校验 产品报价设置 保存并发布
 * @returns {*[]|boolean}
 */
export function checkSaveAndPublishData(){
  let details = this.logisticsProductsDetails || {};
  let editFormData = this.editFormData||{};
  // 原校验分区逻辑所需参数
  let options = {
    // 是否是分段报价
    isSegment:editFormData.isSegment,
    // 是否是分段报价
    isSupportMultiChannel:editFormData.isSupportMultiChannel,
    // 分段类型：head-全包(头程) delivery-派送
    type:"head",
    deliveryType: editFormData.deliveryType,
    startCitySettingWarehouseParams: this.startCitySettingWarehouseParams,
    isConvertOnPartition: this.isConvertOnPartition
  };
  // 校验时错误提示文本集合
  let errorArray = [];
  // 校验步骤
  let checkStep = [
    // 有效时间
    () => checkEffectiveTime(editFormData),
    // 运力商产品
    () => checkHasSelectSupplierProduct(editFormData),
    // 是否有选择货物入仓测量方式、是否支持线下议价、是否支持时效赔付
    () => checkHasSelectLabel(editFormData),
    // 最外层对象参数
    () => checkPublishFirstStepParams(editFormData,{
      currency:this.currency,
      currencyDelivery:this.currencyDelivery,
    }),
    // 全包/头程 城市分区
    () => {
      let label = `分区设置（${ editFormData.isSegment ? "头程" : "全包" }）`;
      let result = checkCityRegionList(this.cityRegionHeaderList,options);
      if(result === true) return true;
      return receiveCheckResult(result,[],label);
    },
    // 派送分区
    () => {
      if(!editFormData.isSegment) return true;
      let label = `分区设置（派送）`;
      let otherOptions = Object.assign({},options, {type:"delivery",});
      let result = checkRegionList(this.deliveryRegionHeaderList,otherOptions);
      if(result === true) return true;
      return receiveCheckResult(result,[],label);
    },
    // 是否推送更新至收藏客户
    () => checkPushOpenRequired(editFormData),
  ]

  let result = startCheckStep(checkStep);
  receiveCheckResult(result,errorArray);

  return errorArray.length ? errorArray : true;
}

/**
 * 校验 保存并发布 的第一级参数
 * @param editFormData
 * @param options
 */
export function checkPublishFirstStepParams(editFormData={},options={}){
  let {currency,currencyDelivery} = options;
  let errorArray = [];
  // 收货城市
  let hasPolCityList = isArray(editFormData.polCityList) && editFormData.polCityList.length;
  if(!hasPolCityList) errorArray.push("请选择 收货城市");
  // 海外仓
  if(!editFormData.overseasWarehouseId) errorArray.push("请选择 海外仓");
  // 派送方式
  if(!editFormData.deliveryType) errorArray.push("请选择 派送方式");
  // 是否支持自提
  if(editFormData.deliveryType !== "ZT"){
    if(!editFormData.selfDelivery) errorArray.push("请选择 是否支持自提");
  }
  if (editFormData.transportType === 'HY') {
    if (!editFormData.shippingCompanyList.length) errorArray.push("请选择 船运公司");
  }
  if (editFormData.transportType === 'KY') {
    if (!editFormData.shippingCompanyList.length) errorArray.push("请选择 航空公司");
  }
  if (editFormData.deliveryType === "HP") {
    if (!editFormData.endDeliveryTypeIds && !editFormData.endDeliveryTypeIds) errorArray.push("请选择 海派尾端派送类型");
  }
  // 可走货物类型
  let hasGoodsTypeList = isArray(editFormData.goodsTypeList) && editFormData.goodsTypeList.length;
  if(!hasGoodsTypeList) errorArray.push("请选择 可走货物类型");

  if(editFormData.chargeType === "KG"){
    // 分泡方式
    if(!editFormData.pointsBubbleWay) errorArray.push("请选择 分泡方式");
    // 体积重比率
    if(!editFormData.volumeWeightRatio) errorArray.push("请输入 体积重比率");
  }else if(editFormData.chargeType === "CBM"){
    // 重量转换
    if(!editFormData.weightVolumeRatio) errorArray.push("请选择 重量转换");
  }
  if (!editFormData.whetherSupportCompensation && editFormData.whetherSupportCompensation !== false) errorArray.push("请选择 是否支持丢货赔付");
  if (!editFormData.closeWarehouseTime) errorArray.push("请选择 截仓时间")
  if (!editFormData.startShipmentTime) errorArray.push("请选择 起运时间")
  if (!editFormData.supportCompensationDesc) errorArray.push("请选择 是否支持丢货赔付")
  if (editFormData.whetherSupportedCompensate && !editFormData.supportedCompensateDesc) errorArray.push("请输入 时效赔付标准")
  if (editFormData.whetherSupportCompensation && !editFormData.supportCompensationDesc) errorArray.push("请输入 丢货赔付标准")

  // 是否多渠道
  if(typeof editFormData.isSupportMultiChannel !== "boolean") errorArray.push("请选择 是否多渠道");
  // 专线api对接渠道代码
  if(!editFormData.isSupportMultiChannel && !editFormData.channelCode) errorArray.push("请输入 专线api对接渠道代码");

  // 币种
  if(editFormData.isSegment){
    if(!currency)  errorArray.push("分区设置（头程） 币种不能为空");
    if(!currencyDelivery && editFormData.deliveryType !== 'ZT')  errorArray.push("分区设置（派送） 币种不能为空");
  }else{
    if(!currency)  errorArray.push("分区设置（全包） 币种不能为空");
  }

  return errorArray.length ? errorArray : true;
}

/**
 * 校验 是否推送更新至收藏客户 及 更新说明
 */
function checkPushOpenRequired(editFormData={}){
  let errorArray = [];
  // 是否推送更新至收藏客户
  if(typeof editFormData.pushOpen !== "boolean") errorArray.push("请选择 是否推送更新至收藏客户");
  // 推送更新说明
  if(editFormData.pushOpen && !editFormData.pushContent) errorArray.push("已勾选推送更新至收藏客户，请填写更新说明");

  return errorArray.length ? errorArray : true;
}



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/utils/checkSaveAndPublish.utils.js